<!-- <perfect-scrollbar [config]="config"> -->

	<div class="my_dashboard">
		<!-- <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner> -->
		<app-header [headerTitle]="headerTitle"></app-header>

		<div class="my_dashboard_page_container">
			<div class="dashboard_component">
				<div class="left_side">
					<div class="db">
						<!-- <div class="current">Current</div> -->
						<div class="title"> Hello <span style="color: #8BF0D1">{{firstName ? firstName : username}}</span>!
							<p *ngIf="userData && userData.lastAccessTime; else notLastAccess" style="margin-bottom: 0px;margin-top: 5px;">You were last here on {{userData.lastAccessTime?.toDate() | date:'longDate'}}</p>
							<ng-template #notLastAccess>
								<p style="margin-bottom: 0px;margin-top: 5px;">Great to see you back.</p>
							</ng-template>
						</div>

						<div class="designbg">
							<img src="../../assets/images/dashboardbg.svg" alt="">
						</div>

					</div>

					<div class="daily_dose_cont">
						<img class="paw" src="../../assets/images/dashboard_images/Kawaii Manga Cat Pawn 2.svg" alt="">
						<div (click)="changeState()" class="full_screen_icon redirect_btn">
							<img src="../../assets/images/outline.svg" alt="">
						</div>

						<div class="daily_dose_container">
							<div class="daily_di">Daily D.O.S.E<span class="tm">TM</span></div>
							<!-- <p class="DAILY_DESC">Just 5 minutes a day will change your professional life!</p> -->
							<div class="absolute_btn" (click)="letsGoDailyDose()">Let's go <img
									src="../../assets/images/dashboard_images/Arrow - Right.png" alt=""></div>
						</div>

						<div class="desc">
							<p class="DAILY_DESC">5 minutes is all you need,</p>
							<p class="DAILY_DESC">to get learning in top speed.</p>
							<p class="DAILY_DESC">Your goals will be ever so close</p>
							<p class="DAILY_DESC">with every tiny, Daily D.O.S.E&trade;!</p>
						</div>

						<!-- <div class="mobileDesc">
							<p>
								5 minutes is all you need, to get learning in top speed. Your goals will be ever so close,
								with every tiny, Daily D.O.S.E!
							</p>
						</div> -->
					</div>

					<div class="days_minutes_container">
						<div class="days_container">
							<img src="../../assets/images/dashboard_images/Group 8.svg" alt="" class="outerImg">

							<!-- <p class="number_days">{{ getStreaks(daysInRow) }}</p> -->
							<p class="number_days">{{ numProgramsCompleted }}</p>

							<p class="days_in_a_row"><b class="subhead">PROGRAMS</b>
								<!-- {{ userProgress ? daysInRow: 0 }} -->
								Completed</p>
						</div>

						<div class="days_container">
							<img src="../../assets/images/dashboard_images/Group 9.svg" alt="" class="outerImg">
							<p class="number_days">{{ hasProgress ? learningThisMonth : 0 }}</p>

							<p class="days_in_a_row"> <b class="subhead">MINUTES</b>
								Learned</p>
						</div>

						<div class="days_container">
							<img src="../../assets/images/dashboard_images/Group 10.svg" alt="" class="outerImg">
							<p class="number_days">{{ dosesCompleted }}</p>

							<p class="days_in_a_row"><b class="subhead">D.O.S.E's</b> Completed
							</p>
						</div>

						<div class="days_container">
							<img src="../../assets/images/dashboard_images/Group 10.svg" alt="" class="outerImg">
							<p class="number_days">{{ hasProgress ? quizzesCompleted : 0 }}</p>

							<p class="days_in_a_row">
								<b class="subhead">QUIZZES</b> Completed
							</p>
						</div>
					</div>

					<div class="calendar">
						<article class="calendar-wrapper">
							<div class="learning_d">Learning Days <span class="purple_dot"></span>
							</div>
							<igx-calendar selection="multi" [formatOptions]="formatOptions" [formatViews]="formatViews"
								[hideOutsideDays]="true" (viewDateChanged)="igxViewDateChanged($event)" #targetCalendar></igx-calendar>
							<span class="target_days">D.O.S.E Target: 20</span>
						</article>
					</div>

					<div class="chalkboard-box">
						<img class="chalkboard-img" [src]="weeklyImagePath" alt="">
						<!-- <img class="chalkboard-flip" src="../../../../../assets/images/dashboard_images/Flip Xmas Gif Top Tips.png" alt=""> -->
						<div class="chalkboard-flip-2">
							<img src="../../../../../assets/images/dashboard_images/TopTips_Flip11-optimized.gif" alt="">
						</div>
					</div>

					<!-- <div class="month_learning_cont">

								<p class="days_left">{{ getRemainingDaysThisMonth() }} days of {{ totalDaysThisMonth() }} left</p>



								<div class="target_container">
									<p class="target">Target</p>
									<p class="learn_minutes">Learn 5 minutes a day for 20 days this month</p>
								</div>

								<div class="targets_container" id="target_date_labels">
									<div class="target" *ngFor="let dateLabel of targetDateLabels"
										[ngClass]="{ 'target_green': dateLabel.isDateLogged, 'target_grey': !dateLabel.isDateLogged }">
									</div>
								</div>
							</div> -->
				</div>

				<div class="right_side">
					<div class="progress_con">
						<div class="container_main_right">
							<div>
								<div class="progress_bars" *ngIf="activePrograms.length >= 1; else noProgressTop">
									<div class="right_h2">
										<div class="progressBar">
											<p class="progress_head">Current Program</p>
											<div class="circle_prog_img top">Fluent</div>
											<circle-progress [outerStrokeGradient]=true
												[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
												[percent]="hasProgress ? activePrograms[0].progress : 0"
												[outerStrokeColor]="'#8aead0'" [innerStrokeColor]="'#000000'"
												[outerStrokeWidth]="getOuterStrokeWidth()"
												[innerStrokeWidth]="getInnerStrokeWidth()"
												[titleFontSize]="'getTitleFontSize()'" [unitsFontSize]="'24'"
												[subtitleFontSize]="'0'" [titleFontWeight]="'900'" [unitsFontWeight]="'600'"
												[subtitleFontWeight]="'500'" [radius]="getRadius()"
												[outerStrokeLinecap]="'circle'" [space]="getSpace()"
												[titleColor]="'#000000'" [unitsColor]="'#000000'"
												[titleFontWeight]="'900'"></circle-progress>
											<h2 class="progress_head2">{{ hasProgress ? activePrograms[0].name : 'No Active Program' }}</h2>
											<!-- <h2 class="progress_head2" #myElement>{{ activePrograms[0].name }}</h2> -->
											<p class="pending3">{{ activeProgramsMessage }}</p>
										</div>

									</div>

									<div class="right_h2">

										<div [ngClass]="isCompleteAlgoBoxOpen ? 'isCompleteAlgoBoxOpen' : ''" class="algorithm-box">
											<div class="top-content-box">
      											<img src="../../../../../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
												<p>“These are the points levels as you complete
													more programs. Stay tuned for some cool
													ways to use your points in the near future!”
												</p>
											</div>
											<div class="main-content-box">
												<table>
													<tr>
														<td>Level 1.</td>
														<td class="algo-heading">Newbie</td>
														<td>You’re on your way!</td>
													</tr>
													<tr>
														<td>Level 2.</td>
														<td class="algo-heading">Apprentice</td>
														<td>Your Committed!</td>
													</tr>
													<tr>
														<td>Level 3.</td>
														<td class="algo-heading">Scholar</td>
														<td>Great Learning Habits!</td>
													</tr>
													<tr>
														<td>Level 4.</td>
														<td class="algo-heading">Sorcerer</td>
														<td>You Burn to Learn!</td>
													</tr>
													<tr>
														<td>Level 5.</td>
														<td class="algo-heading">Visionary</td>
														<td>You LEAD the way!</td>
													</tr>
													<tr>
														<td>Level 6.</td>
														<td class="algo-heading">Wizard 1</td>
														<td>LEARNING Leader!</td>
													</tr>
												</table>
											</div>
										</div>

										<div class="progressBar">
											<p class="progress_head">Completed
												<!-- <img (click)="openAlgorithmBox()" src="../../assets/images/outline.svg" alt="" class="algo-icon"> -->
											</p>
											<div class="circle_prog_img top">SECTIONS</div>
											<!-- <img src="../../assets/images/Video Player Laptop.svg" alt="" class="circle_prog_img"> -->
											<circle-progress [outerStrokeGradient]=true
												[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
												[percent]="sectionsCompleted" [outerStrokeColor]="'#8aead0'"
												[innerStrokeColor]="'#a7f3dc'" [outerStrokeWidth]="getOuterStrokeWidth()"
												[innerStrokeWidth]="getInnerStrokeWidth()"
												[titleFontSize]="'getTitleFontSize()'" [unitsFontSize]="'0'"
												[subtitleFontSize]="'0'" [titleFontWeight]="'1000'"
												[unitsFontWeight]="'900'" [subtitleFontWeight]="'900'"
												[radius]="getRadius()" [outerStrokeLinecap]="'circle'" [space]="getSpace()"
												[titleColor]="'#000000'" [unitsColor]="'#000000'"
												[titleFontWeight]="'900'"></circle-progress>
											<h2 class="progress_head2">Inspirator</h2>
											<p class="pending3">Look at YOU Go!!</p>
										</div>
									</div>

									<div class="right_h2">

										<div [ngClass]="isMonthlyDoseBoxOpen ? 'isMonthlyDoseBoxOpen' : ''" class="algorithm-box">
											<div class="top-content-box">
      											<img src="../../../../../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
												<p>“The more D.O.S.E’s we do, the more we
													develop, and we also create a great
													discipline for solid learning habits.”
												</p>
											</div>
											<div class="main-content-box">
												<table>
													<tr>
														<td class="algo-heading">Level 1.</td>
														<td>0</td>
														<td>D.O.S.E Up</td>
													</tr>
													<tr>
														<td class="algo-heading">Level 2.</td>
														<td>1-10</td>
														<td>D.O.S.E Dabbler</td>
													</tr>
													<tr>
														<td class="algo-heading">Level 3.</td>
														<td>10-15</td>
														<td>D.O.S.E</td>
													</tr>
													<tr>
														<td class="algo-heading">Level 4.</td>
														<td>15-20</td>
														<td>D.O.S.E Hero</td>
													</tr>
													<tr>
														<td class="algo-heading">Level 5.</td>
														<td>20-30</td>
														<td>D.O.S.E Star</td>
													</tr>
													<tr>
														<td class="algo-heading">Level 6.</td>
														<td>30-40</td>
														<td>D.O.S.E Expert</td>
													</tr>
													<tr>
														<td class="algo-heading">Level 7.</td>
														<td>40+</td>
														<td>D.O.S.E Master</td>
													</tr>
												</table>
												<div class="right-circle">
													<div class="circle-heading">
														<p>Monthly</p>
														<p>Goal 20 D.O.S.E’s</p>
													</div>
													<div class="circle-para">
														<p>A D.O.S.E™ is any</p>
														<p>activity you do to</p>
														<p>learn such as a video,</p>
														<p>quiz, podcast, or</p>
														<p>download.</p>
													</div>
												</div>
											</div>
										</div>

										<div class="progressBar">
											<p class="progress_head ">Monthly D.O.S.E's <img (click)="openMonthlyDoseBox()" src="../../assets/images/outline.svg" alt="" class="algo-icon"></p>
											<div class="circle_prog_img top">THIS MONTH</div>
											<!-- <img src="../../assets/images/Frame 81.svg" alt="" class="circle_prog_img"> -->
											<circle-progress [outerStrokeGradient]=true
												[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
												[percent]="dosesCompletedThisMonth" [outerStrokeColor]="'#8aead0'"
												[innerStrokeColor]="'#a7f3dc'" [outerStrokeWidth]="getOuterStrokeWidth()"
												[innerStrokeWidth]="getInnerStrokeWidth()"
												[titleFontSize]="'getTitleFontSize()'" [unitsFontSize]="'0'"
												[subtitleFontSize]="'0'" [titleFontWeight]="'900'" [unitsFontWeight]="'900'"
												[subtitleFontWeight]="'900'" [radius]="getRadius()"
												[outerStrokeLinecap]="'circle'" [space]="getSpace()"
												[titleColor]="'#000000'" [unitsColor]="'#000000'"
												[titleFontWeight]="'900'"></circle-progress>
											<h2 class="progress_head2">Super Star</h2>
											<p class="pending3">{{ doseAlgoRes }}</p>
										</div>
									</div>
								</div>

								<ng-template #noProgressTop>

									<div class="progress_bars">
										<div class="right_h2">
											<div class="progressBar">
												<p class="progress_head">Current Program</p>
												<div class="circle_prog_img">FLUENT</div>
												<!-- <img src="../../assets/images/School Book Trophy.svg" alt="" class="circle_prog_img"> -->
												<circle-progress [outerStrokeGradient]=true
													[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
													[percent]="getDosesCompleted()" [outerStrokeColor]="'#8aead0'"
													[innerStrokeColor]="'#a7f3dc'"
													[outerStrokeWidth]="getOuterStrokeWidth()"
													[innerStrokeWidth]="getInnerStrokeWidth()"
													[titleFontSize]="'getTitleFontSize()'" [unitsFontSize]="'24'"
													[subtitleFontSize]="'0'" [titleFontWeight]="'900'"
													[unitsFontWeight]="'900'" [subtitleFontWeight]="'900'"
													[radius]="getRadius()" [outerStrokeLinecap]="'circle'"
													[space]="getSpace()" [titleColor]="'#000000'" [unitsColor]="'#000000'"
													[titleFontWeight]="'900'"></circle-progress>
												<h2 class="progress_head2">Go To Library</h2>
												<!-- <h2 class="progress_head2" #myElement>Go To Library</h2> -->
												<p class="pending3">In The Learning Centre
												</p>
											</div>
										</div>

										<div class="right_h2">

											<div [ngClass]="isCompleteAlgoBoxOpen ? 'isCompleteAlgoBoxOpen' : ''" class="algorithm-box">
												<div class="top-content-box">
													  <img src="../../../../../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
													<p>“These are the points levels as you complete
														more programs. Stay tuned for some cool
														ways to use your points in the near future!”
													</p>
												</div>
												<div class="main-content-box">
													<table>
														<tr>
															<td>Level 1.</td>
															<td class="algo-heading">Newbie</td>
															<td>You’re on your way!</td>
														</tr>
														<tr>
															<td>Level 2.</td>
															<td class="algo-heading">Apprentice</td>
															<td>Your Committed!</td>
														</tr>
														<tr>
															<td>Level 3.</td>
															<td class="algo-heading">Scholar</td>
															<td>Great Learning Habits!</td>
														</tr>
														<tr>
															<td>Level 4.</td>
															<td class="algo-heading">Sorcerer</td>
															<td>You Burn to Learn!</td>
														</tr>
														<tr>
															<td>Level 5.</td>
															<td class="algo-heading">Visionary</td>
															<td>You LEAD the way!</td>
														</tr>
														<tr>
															<td>Level 6.</td>
															<td class="algo-heading">Wizard 1</td>
															<td>LEARNING Leader!</td>
														</tr>
													</table>
												</div>
											</div>

											<div class="progressBar">
												<p class="progress_head">Completed <img (click)="openAlgorithmBox()" src="../../assets/images/outline.svg" alt="" class="algo-icon"></p>
												<div class="circle_prog_img">SECTIONS</div>
												<!-- <img src="../../assets/images/Video Player Laptop.svg" alt="" class="circle_prog_img"> -->
												<circle-progress [outerStrokeGradient]=true
													[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
													[percent]="sectionsCompleted" [outerStrokeColor]="'#8aead0'"
													[innerStrokeColor]="'#a7f3dc'"
													[outerStrokeWidth]="getOuterStrokeWidth()"
													[innerStrokeWidth]="getInnerStrokeWidth()"
													[titleFontSize]="'getTitleFontSize()'" [unitsFontSize]="'0'"
													[subtitleFontSize]="'0'" [titleFontWeight]="'1000'"
													[unitsFontWeight]="'900'" [subtitleFontWeight]="'900'"
													[radius]="getRadius()" [outerStrokeLinecap]="'circle'"
													[space]="getSpace()" [titleColor]="'#000000'" [unitsColor]="'#000000'"
													[titleFontWeight]="'900'"></circle-progress>
												<h2 class="progress_head2">Pick A Program</h2>
												<p class="pending3">It's lonely in here!</p>
											</div>
										</div>

										<div class="right_h2">

											<div [ngClass]="isMonthlyDoseBoxOpen ? 'isMonthlyDoseBoxOpen' : ''" class="algorithm-box">
												<div class="top-content-box">
													  <img src="../../../../../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
													<p>“The more D.O.S.E’s we do, the more we
														develop, and we also create a great
														discipline for solid learning habits.”
													</p>
												</div>
												<div class="main-content-box">
													<table>
														<tr>
															<td class="algo-heading">Level 1.</td>
															<td>0</td>
															<td>D.O.S.E Up</td>
														</tr>
														<tr>
															<td class="algo-heading">Level 2.</td>
															<td>1-10</td>
															<td>D.O.S.E Dabbler</td>
														</tr>
														<tr>
															<td class="algo-heading">Level 3.</td>
															<td>10-15</td>
															<td>D.O.S.E</td>
														</tr>
														<tr>
															<td class="algo-heading">Level 4.</td>
															<td>15-20</td>
															<td>D.O.S.E Hero</td>
														</tr>
														<tr>
															<td class="algo-heading">Level 5.</td>
															<td>20-30</td>
															<td>D.O.S.E Star</td>
														</tr>
														<tr>
															<td class="algo-heading">Level 6.</td>
															<td>30-40</td>
															<td>D.O.S.E Expert</td>
														</tr>
														<tr>
															<td class="algo-heading">Level 7.</td>
															<td>40+</td>
															<td>D.O.S.E Master</td>
														</tr>
													</table>
													<div class="right-circle">
														<div class="circle-heading">
															<p>Monthly</p>
															<p>Goal 20 D.O.S.E’s</p>
														</div>
														<div class="circle-para">
															<p>A D.O.S.E™ is any</p>
															<p>activity you do to</p>
															<p>learn such as a video,</p>
															<p>quiz, podcast, or</p>
															<p>download.</p>
														</div>
													</div>
												</div>
											</div>

											<div class="progressBar">
												<p class="progress_head">Monthly D.O.S.E's <img (click)="openMonthlyDoseBox()" src="../../assets/images/outline.svg" alt="" class="algo-icon"></p>
												<div class="circle_prog_img">THIS MONTH</div>
												<!-- <img src="../../assets/images/Frame 81.svg" alt="" class="circle_prog_img"> -->
												<circle-progress [outerStrokeGradient]=true
													[outerStrokeGradientStopColor]="'#7671EB'" [backgroundPadding]="-50"
													[percent]="dosesCompletedThisMonth" [outerStrokeColor]="'#8aead0'"
													[innerStrokeColor]="'#a7f3dc'"
													[outerStrokeWidth]="getOuterStrokeWidth()"
													[innerStrokeWidth]="getInnerStrokeWidth()"
													[titleFontSize]="'getTitleFontSize()'" [unitsFontSize]="'0'"
													[subtitleFontSize]="'0'" [titleFontWeight]="'900'"
													[unitsFontWeight]="'900'" [subtitleFontWeight]="'900'"
													[radius]="getRadius()" [outerStrokeLinecap]="'circle'"
													[space]="getSpace()" [titleColor]="'#000000'" [unitsColor]="'#000000'"
													[titleFontWeight]="'900'"></circle-progress>
												<h2 class="progress_head2">Let's Begin</h2>
												<p class="pending3">Just 5 min to begin!</p>
											</div>
										</div>
									</div>
								</ng-template>
							</div>
						</div>


						<div class="social_media_container desktop_social_media"
							[ngClass]="{ 'marginB': !activePrograms.length}">

							<!-- Podcast-Slide For Desktop Start -->
							<div class="extra-box-for-slide"></div>
							<div [ngClass]="{'isPodcastSlideOpen': currentPipValue === 'open', 'isPodcastSlideMinimize': currentPipValue === 'minimize', 'isPodcastSlideMaximize': currentPipValue === 'maximize'}" class="podcast-slide">
								<div class="top-content">
									<div class="left-box">
										Latest Daily D.O.S.E&trade; Podcast
									</div>
									<div class="right-box">
										<mat-icon (click)="minimizePodcastSlide()" style="transform: rotate(90deg);">open_in_new_down</mat-icon>
										<mat-icon (click)="closePodcastSlide()" style="transform: rotate(90deg);">close</mat-icon>
									</div>
								</div>
								<div class="middle-content">
									<div class="left-box">
										<img [src]="selectedPodcast && selectedPodcast.artwork_url ? selectedPodcast.artwork_url : '../../assets/images/Daily D.O.S.E Podcast TILE_Lemon.png'" alt="podcast image">
									</div>
									<div class="right-box">
										<div class="top-player-box">
											<div class="play-btn">
												<mat-icon (click)="onPlayPause()">{{isPlaying ? 'pause' : 'play_arrow'}}</mat-icon>
											</div>
											<div class="date-titile" *ngIf="!isLoadingWavesurfer; else loadingWavesurfer">
												<div class="date" *ngIf="selectedPodcast && selectedPodcast.formattedPublishingDate">{{ selectedPodcast.formattedPublishingDate }}</div>
												<!-- <div class="podcast-title">{{ selectedPodcast && selectedPodcast.title ? selectedPodcast.title : "" }}</div> -->
												<marquee class="podcast-title" *ngIf="selectedPodcast && selectedPodcast.title; else noTitle" style="color: white;" behavior="scroll" direction="left" scrollamount="2">{{selectedPodcast.title}}</marquee>
												<ng-template #noTitle>
													<marquee class="podcast-title" behavior="scroll" direction="left" scrollamount="2"></marquee>
												</ng-template>
											</div>

											<ng-template #loadingWavesurfer>
												<p class="podcast-title">
													Loading podcast audio...
												</p>
											</ng-template>
										</div>

										<div class="middle-player-box">
											<div #waveform></div>
										</div>

										<div class="bottom-player-box">
											<div class="timeline"><span>{{formatTime(currentTime)}}</span> /{{formatTime(durationTime)}}</div>
											<!-- <input type="range" id="volumeRange" min="0" max="100" step="1" value="100" (input)="changeVolume($event.target.value)"> -->
											<div class="volume">
												<mat-icon (click)="toggleMute()">{{ isMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
												<mat-slider *ngIf="!isiPhone"
													class="example-margin"
													[max]="100"
													[min]="0"
													[step]="1"
													[value]="100"
													(input)="changeVolume($event.value)">
												</mat-slider>
											</div>

											<div class="action-btn-box" [ngClass]="{'gapForIphone': isiPhone}">
												<mat-icon (click)="skipBackwardFn()" id="ten">replay_10</mat-icon>
												<mat-icon (click)="skipForwardFn()" id="ten">forward_10</mat-icon>
												<mat-icon (click)="toggleIsLiked()" [ngClass]="{'active': isLiked}">favorite</mat-icon>
												<mat-icon (click)="toggleCommentBox()" [ngClass]="{'active': isComment}">sms</mat-icon>
											</div>
										</div>
									</div>
								</div>
								<div class="bottom-content">
									<button [ngClass]="{'active': isDoseDetailsOpen}" (click)="toggleDoseDetails()">D.O.S.E Details <mat-icon>navigate_next</mat-icon></button>
									<button [ngClass]="{'active': isMoreDetailsOpen}" (click)="toggleMoreDetails()">More D.O.S.E’s <mat-icon>navigate_next</mat-icon></button>
								</div>
							</div>
							<div [ngClass]="{'isDoseDetailsOpen': isDoseDetailsOpen}" [ngStyle]="{ top: (mDesktopHeight - 20) + 'px' }" class="more-content dose-details">
								<div class="inner-content">
									<h4 class="details-title">{{ selectedPodcast && selectedPodcast.title ? selectedPodcast.title : "" }}</h4>
									<p class="details-description" [innerHTML]="selectedPodcast && selectedPodcast.description ? selectedPodcast.description : ''">
									</p>
								</div>
							</div>
							<div [ngClass]="{'isDoseDetailsOpen': isMoreDetailsOpen}" [ngStyle]="{ top: (mDesktopHeight - 20) + 'px' }" class="more-content more-dose">
								<div class="inner-content">
									<div (click)="urlIndex === i+1 ? onPlayPause() : onUrlChange(i, true)" class="playlist-box" *ngFor="let podcast of podcasts | slice: 1; let i = index">
										<div class="left-box">
											<img [src]="podcast && podcast.artwork_url ? podcast.artwork_url : '../../assets/images/Daily D.O.S.E Podcast TILE_Lemon.png'" alt="Other Podcast Image">
											<div [ngClass]="{'active-dose': urlIndex === i+1}" class="play-btn">
												<mat-icon>{{ urlIndex === i+1 && isPlaying ? 'pause' : 'play_arrow'}}</mat-icon>
											</div>
										</div>
										<div class="right-box">
											<div class="date">{{ podcast.formattedPublishingDate }}</div>
											<div class="play-title">{{ podcast && podcast.title ? podcast.title : "" }}</div>
											<!-- <div class="middle-player-box">
												<div [id]="'waveform'+i"></div>
											</div> -->

											<div class="middle-player-box more-dose-bars">
												<span *ngFor="let item of customWaveSurfer; let j = index"
												[style.height.px]="j % 2 === 0 ? (j % 3 === 0 ? '8' : '15') : (j % 4 === 0 ? '22' : '8')"
													  [style.background-color]="(j < customWaveSurfer.length * wavesProgress[i + 1]) ? 'black' : 'gainsboro'">
													</span>
											</div>

											<div class="timeline">{{ podcast && podcast.duration ? formatTime(podcast.duration) : "" }}</div>
										</div>
									</div>
								</div>
							</div>
							<div [ngClass]="{'isDoseDetailsOpen': isCommentBoxOpen}" [ngStyle]="{ top: (mDesktopHeight - 20) + 'px' }" class="more-content comment-box">
								<div class="inner-content" style="position: relative;">
									<div class="comment-head">
										<h4 class="details-title">Write Comments</h4>
										<button (click)="saveComment()">Save</button>
									</div>
									<textarea [maxLength]="400" (input)="onInputChange($event)" [(ngModel)]="commentBoxText"></textarea>
									<p style="position: absolute;bottom: -5px;right: 25px;font-size: 12px;color: #c6c6c6;">{{commentCharacterCount}}/400</p>
								</div>
							</div>
							<!-- Podcast-Slide For Desktop End -->


							<div class="care-mini-box">
								<!-- <div class="customHeart">
									<div class="heart" *ngIf="showHeart" (click)="showEmojis('miniClip')">
										<img *ngIf="selectedPodcastEmojiType !== ''" src="../../../../../assets/images/socialMediaHeartFilled.png" alt="">
										<img *ngIf="selectedPodcastEmojiType == ''" src="../../../../../assets/images/socialMediaHeart.png" alt="">
									</div>

									<div *ngIf="showEmojiTab3" class="emojisContainer">
											<div *ngFor="let emojiContent of emojisList; let i = index;"
											[ngClass]="{'highlightedEmoji': emojiContent.emotionType === highlightedPodcastEmojiType}"
											[class.emoji-animate]="emojiContent.emotionType === selectedPodcastEmojiType"
											(click)="handleEmojiClick(emojiContent, 'miniClip', 'miniClip')"
										  >
											{{ emojiContent.emoji }}
										  </div>
									</div>
								</div> -->
								<img #desktopCardImage (load)="onDesktopImageLoad(desktopCardImage)"  (click)="openMiniclipsModal()" class="miniClipCoverImage" [src]="miniClipCoverImage ? miniClipCoverImage : 'assets/gifs/mini-clips-image.gif'" />
							</div>

							<div class="quote-text-box quote_card" id="quote-box"  [ngStyle]="{ height: mDesktopHeight + 'px' }">
								<!-- <div class="customHeart">
									<div class="heart" *ngIf="showHeart2" (click)="showEmojis('quote')">
										<img src="../../../../../assets/images/socialMediaHeart.png" alt="">

										<img *ngIf="selectedQuoteEmojiType !== ''" src="../../../../../assets/images/socialMediaHeartFilled.png" alt="">
										<img *ngIf="selectedQuoteEmojiType == ''" src="../../../../../assets/images/socialMediaHeart.png" alt="">
									</div>

									<div *ngIf="showEmojiTab2" class="emojisContainer">

										<div *ngFor="let emojiContent of emojisList; let i = index;"
										[ngClass]="{'highlightedEmoji': emojiContent.emotionType === highlightedQuoteEmojiType}"
										[class.emoji-animate]="emojiContent.emotionType === selectedQuoteEmojiType"
										(click)="handleEmojiClick(emojiContent, randomQuote.id, 'quote')"
									  >
										{{ emojiContent.emoji }}
									  </div>
									</div>
								</div> -->

								<!-- <div class="quote-content">
									<img src="../../assets/images/double-quotes (1).png" alt="" class="comma">
									<p class="comma" style="font-size: 115px;  margin-bottom: -81px;">“</p>
									<p class="ony_learn_text" id="quote-text"
										[ngClass]="{long: (randomQuote.text?.length < 100), verylong: (randomQuote.text?.length < 200) && (randomQuote.text?.length > 100)}">
										{{ randomQuote.text }}</p>
								</div>
								<p class="librarian">{{ randomQuote.quotedBy }}</p> -->

								<div class="quote-like-box">
									<!-- <mat-icon [ngClass]="{'active': isQuoteLiked}" (click)="likeQuoteFn(isQuoteLiked ? 'unlike' : 'like')">favorite</mat-icon> -->
								</div>
								<!-- <div class="quote-content"> -->
									<img [src]="dailyQuoteSrc">
								<!-- </div> -->
							</div>

							<div (click)="openPodcastSlide()" class="podcast-box"  [ngStyle]="{ height: mDesktopHeight + 'px' }">
								<!-- <div class="customHeart">
									<div class="heart" *ngIf="showHeart" (click)="showEmojis('podcast')">
										<img *ngIf="selectedPodcastEmojiType !== ''" src="../../../../../assets/images/socialMediaHeartFilled.png" alt="">
										<img *ngIf="selectedPodcastEmojiType == ''" src="../../../../../assets/images/socialMediaHeart.png" alt="">
									</div>

									<div *ngIf="showEmojiTab" class="emojisContainer">
											<div *ngFor="let emojiContent of emojisList; let i = index;"
											[ngClass]="{'highlightedEmoji': emojiContent.emotionType === highlightedPodcastEmojiType}"
											[class.emoji-animate]="emojiContent.emotionType === selectedPodcastEmojiType"
											(click)="handleEmojiClick(emojiContent, 'podcast', 'podcast')"
										  >
											{{ emojiContent.emoji }}
										  </div>
									</div>
								</div> -->

								<div class="head-box">
									<div class="logo-name">
										<img class="logo" src="../../assets/icons/icon-72.png" alt="">
										<div>IgniteHumans.com</div>
									</div>

									<div class="whatsNew">What's New</div>
								</div>

								<div class="podcast-img">
									<img [src]="podcastLoaderImg" alt="">
									<div class="static-play-btn">
										<mat-icon>play_arrow</mat-icon>
									</div>
								</div>
								<div class="bottom-txt">
									<!-- Listen NOW at www.ignitehumans.com -->
									Listen NOW for some inspo!✨
								</div>
							</div>
						</div>

						<!-- <div style="margin-top: 40px" class="mobile_social_media">
							<div class="carousel-container" (touchstart)="onTouchStart($event)"
								(touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">

								<div class="carousel-slides"
									[ngStyle]="{'transform': 'translateX(' + translateValue + ')'}">

									<div class="carousel-slide">
										<img (click)="openMiniclipsModal()" style="margin-top: 30px !important;" class="miniClipCoverImage"
											[src]="miniClipCoverImage ? miniClipCoverImage : 'assets/gifs/mini-clips-image.gif'" />
									</div>

									<div class="carousel-slide" id="quote-boxMobile">
										<div class="only_learn">
											<img src="../../assets/images/double-quotes (1).png" alt="" class="comma">
											<p class="ony_learn_text" id="quote-text"
												[ngClass]="{long: (randomQuote.text?.length < 100), verylong: (randomQuote.text?.length < 200) && (randomQuote.text?.length > 100)}">
												{{ randomQuote.text }}</p>
											<p class="librarian">{{ randomQuote.quotedBy }}</p>
										</div>
									</div>

									<div class="carousel-slide">
										<div class="coming_soon mobile-coming_soon">
											<div class="social_media socialM">

												<div class="social_head">
													<div class="soacial_name_container">
														<div class="logo"><img src="../../assets/images/logoIcn.jpg"
																alt="">
														</div>
														<div>Ignite Humans</div>
													</div>

													<div>What's New</div>
												</div>

												<div class="coming_soon_img">
													<img src="../../assets/images/Daily D.O.S.E Podcast TILE_Lemon.png"
														alt="">
												</div>
												<div class="insta_row c_s" style="
											width: 100%; position: unset !important; height: 34px !important;">
													<span class="coming_soon_text">Listen NOW at
														www.ignitehumans.com</span>
													<span class="coming_soon_text"></span>


												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="carousel-pagination">
									<button class="carousel-pagination-item" *ngFor="let slide of slides; let i = index"
										[ngClass]="{'active': currentIndex === i, 'hideInTabPagination': i === 2}"
										(click)="goToSlide(i)"></button>
								</div>
							</div>
						</div> -->

						<div class="phone_social_media_cards">
							<div class="inner-container">
								<div class="media-card miniclipcard" id="cardElement">
									<img #cardElement (load)="onImageLoad(cardElement)" (click)="openMiniclipsModal()" class="card-img"
										[src]="miniClipCoverImage ? miniClipCoverImage : 'assets/gifs/mini-clips-image.gif'" />
								</div>

								<div class="media-card quote quote_card" id="quoteBG" [ngStyle]="{ height: mHeight + 'px' }">
									<!-- <div class="inner-box">
										<div class="quote-content">
											<div style="text-align: center;">
												<img src="../../assets/images/double-quotes (1).png" alt="" class="comma">
												<p class="ony_learn_text" id="quote-text">
													{{ randomQuote.text }}</p>
											</div>
										</div>
										<p class="librarian">{{ randomQuote.quotedBy }}</p>
									</div> -->
									<div class="quote-like-box">
										<!-- <mat-icon [ngClass]="{'active': isQuoteLiked}" (click)="likeQuoteFn(isQuoteLiked ? 'unlike' : 'like')">favorite</mat-icon> -->
									</div>

									<img [src]="dailyQuoteSrc">
								</div>

								<div (click)="openBottomSheet()" class="media-card podcast" [ngStyle]="{ height: mHeight + 'px' }">
									<div class="head-box">
										<div class="logo-name">
											<img class="logo" src="../../assets/icons/icon-72.png" alt="">
											<div>IgniteHumans.com</div>
										</div>

										<div class="whatsNew">What's New</div>
									</div>

									<div class="podcast-img">
										<img [src]="podcastLoaderImg" alt="">
										<div class="static-play-btn">
											<mat-icon>play_arrow</mat-icon>
										</div>
									</div>
									<div class="bottom-txt">
										<!-- Listen NOW at www.ignitehumans.com -->
										Listen NOW for some inspo!✨
									</div>
								</div>
							</div>
						</div>


						<!-- <div class="phone_social_media_cards">
							<div class="inner-container">
								<div class="media-card miniclipcard">
									<img (click)="openMiniclipsModal()" class="card-img"
										[src]="miniClipCoverImage ? miniClipCoverImage : 'assets/gifs/mini-clips-image.gif'" />
								</div>

								<div class="media-card quote" id="quoteBG">
									<div class="inner-box">
										<div class="quote-content">
											<img src="../../assets/images/double-quotes (1).png" alt="" class="comma">
											<p class="ony_learn_text" id="quote-text"
												[ngClass]="{long: (randomQuote.text?.length < 100), verylong: (randomQuote.text?.length < 200) && (randomQuote.text?.length > 100)}">
												{{ randomQuote.text }}</p>
										</div>
										<p class="librarian">{{ randomQuote.quotedBy }}</p>
									</div>
								</div>

								<div class="media-card podcast">
									<div class="head-box">
										<div class="logo-name">
											<img class="logo" src="../../assets/images/logoIcn.jpg" alt="">
											<div>Ignite Humans</div>
										</div>

										<div>What's New</div>
									</div>

									<div class="podcast-img">
										<img src="../../assets/images/Daily D.O.S.E Podcast TILE_Lemon.png"
											alt="">
									</div>
									<div class="bottom-txt">
										<span>Listen NOW at www.ignitehumans.com</span>
									</div>
								</div>
							</div>
						</div> -->

						<!-- social media for mobile  -->

						<div class="active_prog_container">
							<div class="active_prog_container_main" *ngIf="activePrograms.length >= 1; else noProgress">
								<p class="active_prog_head">Active Programs</p>
								<div class="inprog" *ngIf="isAnyProgramInProgress()">
									In Progress
								</div>
								<div *ngFor="let program of activePrograms">
									<div class="active_prog_container_main_row" *ngIf="program.progress !== 100">
										<div class="program-wrapper">
											<div class="row_head">{{ program.name }}</div>
											<div class="progress-line">
												<div [ngStyle]="{'width': program.progress + '%', 'background': '#8BEFD1'}"></div>
											</div>
											<div class="row_details">
												<div class="hrs">
													<img src="../../assets/images/Time Circle.svg" alt="">
													<p class="tenhrs">{{ program.courseTime ?
														getFormattedCourseTime(program.courseTime) : "00:00" }}</p>
												</div>
												<div class="hrs sections">
													<img src="../../assets/images/Category.svg" alt="">
													<p class="tenhrs">{{ program.numberOfSections }} Sections</p>
												</div>

												<div class="hrs last-active" *ngIf="program.lastUpdatedAt">
													<p class="tenhrs">Last Active: {{ program.lastUpdatedAt?.toDate() | date:'dd/MM/yy' }}</p>
												</div>

											</div>
										</div>
										<button class="Launc_bh" (click)="openProgram(program)">
											Launch <img src="../../assets/images/Arrow - Right.svg" alt="">
										</button>
									</div>
								</div>

									<div class="inprog" style="background-color: #7675EA !important; color: white !important" *ngIf="isAnyProgramComplete()">Completed</div>

									<div *ngFor="let program of activePrograms">
										<div class="active_prog_container_main_row" *ngIf="program.progress === 100">
											<div class="program-wrapper">
												<div class="row_head">{{ program.name }}</div>
												<div class="progress-line">
													<div [ngStyle]="{'width': program.progress + '%', 'background': '#7675EA'}"></div>
												</div>
												<div class="row_details">
													<div class="hrs">
														<img src="../../assets/images/Time Circle.svg" alt="">
														<p class="tenhrs">{{ program.courseTime ?
															getFormattedCourseTime(program.courseTime) : "00:00" }}</p>
													</div>

													<div class="hrs sections">
														<img src="../../assets/images/Category.svg" alt="">
														<p class="tenhrs">{{ program.numberOfSections }} Sections</p>
													</div>

													<div class="last-active">
														<div class="hrs" *ngIf="program.completedAt">
															<p class="tenhrs">Completed: {{ program.completedAt?.toDate() | date:'dd/MM/yy' }}</p>
														</div>

														<div class="hrs" *ngIf="program.lastUpdatedAt">
															<p class="tenhrs">Last Active: {{ program.lastUpdatedAt?.toDate() | date:'dd/MM/yy' }}</p>
														</div>
													</div>

												</div>
											</div>
											<button class="Launc_bh" (click)="openProgram(program)">
												Launch <img src="../../assets/images/Arrow - Right.svg" alt="">
											</button>
										</div>
									</div>
								</div>

								<ng-template #noProgress>
									<!-- No Active Programs -->

									<div class="no_prog_box_main" *ngIf="activeProgramsLoaded">
										<div class="no_prog_box">
											<p style="margin-bottom: 2px"> Hey {{username}}!</p>
											<p>Looks like you have no Active Programs?</p>
											<p>Let's get you started on your next</p>
											<p>learning Adventure</p>
										</div>
										<button class="letsgo_btn" [routerLink]="['/my-library']">
											Let's Go <img src="../../assets/images/Arrow - Right.svg" alt="">
										</button>
									</div>
								</ng-template>
							</div>



					</div>
				</div>
			</div>

			<div class="stuff-overlay-wrapper" (click)="changeState()" *ngIf="state == 'open'">
				<div class="left-stuff" [@widthGrow]="state">

					<div (click)="changeState()" class="cross_btn"><img src="../../assets/images/crossbtn.svg" alt=""></div>
					<div class="card_details_container">

						<div class="card_details">
							<p class="head_card">
								What’s a Daily D.O.S.E&trade;?
							</p>



							<p style="margin-bottom: 10px;">D.O.S.E&trade; is an Acrostic for Dopamine, Oxytocin, Serotonin and Endorphin. They are the 4 Happy
								Hormones
								that are here to help us feel great!</p>

							<div class="harmone-container">
								<div class="left-box">
									<div class="hormone"><span class="prog_subhead">DOPAMINE:</span> <span class="hormone_name">Reward
											Centre</span></div>

									<div class="hormone"><span class="prog_subhead">OXYTOCIN:</span> <span class="hormone_name">Love
											Drug</span>
									</div>

									<div class="hormone"><span class="prog_subhead">SEROTONIN:</span> <span class="hormone_name">Mood
											Meter</span></div>

									<div class="hormone"><span class="prog_subhead">ENDORPHIN:</span> <span class="hormone_name">Pain
											Killer</span></div>
								</div>

								<div class="right-box">
									<img src="../assets/gifs/fixed_gif_transparent.gif" alt="">
								</div>
							</div>

							<p style="margin-top: 10px"><span style="font-weight: 700;color: black;">DOPAMINE: </span> Finish a task. Celebrate little wins.</p>
							<p><span style="font-weight: 700;color: black;">OXYTOCIN: </span> Hug. Hand Hold. Play with a dog (or a bub). And give out compliments.</p>
							<p><span style="font-weight: 700;color: black;">SEROTONIN: </span> Gets us grounded. Get in the sun, have a run, and meditate</p>
							<p><span style="font-weight: 700;color: black;">ENDORPHIN: </span> Dance. Laugh. Exercise. Eat dark chocolate.</p>

							<p>At IGNITE, we want you to be able to dose up on the 4 Happy Hormones to help you feel great.
								So, meet Flip, who is here to help encourage you to have your D.O.S.E&trade; of learning,
								everyday.
								Your beautiful brain loves repetition, and thrives when good habits form,
								so Flip will be with you, every single step of the way.</p>

							<p class="head_card">
								What’s a D.O.S.E&trade;?
							</p>

							<!-- <p>A D.O.S.E equals one Unit of learning. A single Unit is usually between 3 and 7 minutes long.
								If you learn every day for 5 days you’ll earn a “streak”, and 20 days in a month? Well, you’ll
								be a
								champ!</p> -->
							<p>A D.O.S.E&trade; is any activity such as a video, a download, a mini clip, or even a quiz. If you learn for 5 days in a row you'll earn a "streak", and 20 days in a month is the goal.</p>

							<p>Remember, long term change only occurs with regular increments. Neurons that fire together, wire
								together, so Flip will be your reminder to build those learning muscles, and get your daily
								hit of
								Happy Hormones.</p>
						</div>

					</div>

				</div>
			</div>
		</div>
	</div>



	<!-- </perfect-scrollbar> -->